import { useCallback, useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const useFormActions = (resource) => {
  const { onSubmit } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = useCallback(async () => {
    try {
      setDeleting(true);
      await resource.delete();
      setDeleting(false);
    } catch (err) {
      setDeleting(false);
    }
  }, [resource]);

  const onDeleteSuccess = useCallback(() => {
    clearModalCollection();
  }, [clearModalCollection]);

  const handleSubmit = useCallback(async () => {
    try {
      setSubmitting(true);
      const resp = await onSubmit();
      setSubmitting(false);

      if (resp) {
        clearModalCollection();
      }

      return resp;
    } catch (err) {
      setSubmitting(false);
      return undefined;
    }
  }, [onSubmit, clearModalCollection]);

  const showDeleteButton = resource.meta().canDelete();
  const showSubmitButton = resource.meta().canPost() || resource.meta().canPut();
  const showActions = showDeleteButton || showSubmitButton;


  return {
    showActions,
    showDeleteButton,
    showSubmitButton,
    handleSubmit,
    handleDelete,
    onDeleteSuccess,
    submitting,
    deleting,
  };
};
